import { Link } from "react-router-dom";
import { 
  Code2, 
  Target, 
  Heart, 
  Rocket,
  ArrowRight,
  Terminal,
  Lightbulb,
  Users,
  Award
} from "lucide-react";

const AboutPage = () => {
  const values = [
    {
      icon: Target,
      title: "Kalite Odaklı",
      description: "Her projede en yüksek kod kalitesi standartlarını uyguluyoruz."
    },
    {
      icon: Heart,
      title: "Müşteri Memnuniyeti",
      description: "Müşteri beklentilerini aşmak için sürekli çalışıyoruz."
    },
    {
      icon: Lightbulb,
      title: "Yenilikçi Yaklaşım",
      description: "En güncel teknolojileri takip eder, yenilikçi çözümler sunarız."
    },
    {
      icon: Users,
      title: "İşbirliği",
      description: "Müşterilerimizle şeffaf ve açık iletişim kuruyoruz."
    }
  ];

  const milestones = [
    { year: "2019", title: "Kuruluş", description: "BF Code Labs'ın temelleri atıldı." },
    { year: "2020", title: "İlk Büyük Proje", description: "İlk kurumsal mobil uygulama projemiz." },
    { year: "2022", title: "AI Çözümleri", description: "Yapay zeka hizmetleri portföye eklendi." },
    { year: "2024", title: "50+ Proje", description: "50'den fazla başarılı proje tamamlandı." }
  ];

  return (
    <div className="pt-16 md:pt-20" data-testid="about-page">
      {/* Hero */}
      <section className="py-20 bg-[#0a0a0f] relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-30" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-[#00d4aa] font-mono text-sm mb-4 block">
                {'// HAKKIMIZDA'}
              </span>
              <h1 className="text-4xl sm:text-5xl font-bold text-[#f0f0f5] mb-6">
                Kod Yazıyoruz,{" "}
                <span className="gradient-text">Gelecek İnşa Ediyoruz</span>
              </h1>
              <p className="text-lg text-[#9ca3af] leading-relaxed mb-8">
                BF Code Labs olarak, modern yazılım çözümleri ile işletmelerin 
                dijital dönüşümüne katkıda bulunuyoruz. Deneyimli ekibimiz ve 
                yenilikçi yaklaşımımızla her projeyi başarıyla tamamlıyoruz.
              </p>
              
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-3 px-4 py-3 bg-[#16161f] border border-[#2a2a3a] rounded-lg">
                  <Award className="w-6 h-6 text-[#00d4aa]" />
                  <div>
                    <p className="text-[#f0f0f5] font-semibold">5+ Yıl</p>
                    <p className="text-[#9ca3af] text-sm">Deneyim</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-4 py-3 bg-[#16161f] border border-[#2a2a3a] rounded-lg">
                  <Rocket className="w-6 h-6 text-[#0ea5e9]" />
                  <div>
                    <p className="text-[#f0f0f5] font-semibold">50+</p>
                    <p className="text-[#9ca3af] text-sm">Proje</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="bg-[#16161f] border border-[#2a2a3a] rounded-xl p-8">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-[#00d4aa] to-[#0ea5e9] flex items-center justify-center">
                    <Code2 className="w-10 h-10 text-[#0a0a0f]" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-[#f0f0f5]">Murat Tabu</h3>
                    <p className="text-[#00d4aa] font-mono text-sm">Kurucu & Geliştirici</p>
                  </div>
                </div>
                
                <p className="text-[#9ca3af] leading-relaxed mb-6">
                  "Yazılım geliştirme sadece kod yazmak değil, problemlere 
                  yaratıcı çözümler üretmektir. Her projede müşterilerimizin 
                  vizyonunu gerçeğe dönüştürmek için çalışıyoruz."
                </p>

                <div className="flex items-center gap-4 pt-4 border-t border-[#2a2a3a]">
                  <div className="flex gap-2">
                    <span className="tech-badge text-xs">React</span>
                    <span className="tech-badge text-xs">Python</span>
                    <span className="tech-badge text-xs">AI/ML</span>
                  </div>
                </div>
              </div>
              
              <div className="absolute -top-4 -right-4 w-24 h-24 bg-[#00d4aa]/10 rounded-full blur-2xl" />
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#0ea5e9]/10 rounded-full blur-2xl" />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#12121a]" data-testid="values-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-[#00d4aa] font-mono text-sm mb-4 block">
              {'// DEĞERLERİMİZ'}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#f0f0f5] mb-4">
              Neye İnanıyoruz?
            </h2>
            <p className="text-[#9ca3af] max-w-2xl mx-auto">
              İş yapış şeklimizi ve müşterilerimize yaklaşımımızı şekillendiren temel değerlerimiz.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="service-card card-hover text-center"
                data-testid={`value-card-${index}`}
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#00d4aa]/20 to-[#0ea5e9]/20 border border-[#2a2a3a] flex items-center justify-center mx-auto mb-4">
                  <value.icon className="w-7 h-7 text-[#00d4aa]" />
                </div>
                <h3 className="text-lg font-semibold text-[#f0f0f5] mb-2">
                  {value.title}
                </h3>
                <p className="text-[#9ca3af] text-sm">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-[#0a0a0f]" data-testid="timeline-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-[#00d4aa] font-mono text-sm mb-4 block">
              {'// YOLCULUĞUMUZ'}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#f0f0f5] mb-4">
              Kilometre Taşları
            </h2>
          </div>

          <div className="relative">
            {/* Timeline line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-px h-full bg-gradient-to-b from-[#00d4aa] via-[#0ea5e9] to-[#a855f7]" />

            <div className="space-y-12">
              {milestones.map((milestone, index) => (
                <div
                  key={index}
                  className={`flex flex-col md:flex-row items-center gap-8 ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                  data-testid={`milestone-${index}`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                    <div className={`inline-block bg-[#16161f] border border-[#2a2a3a] rounded-xl p-6 ${
                      index % 2 === 0 ? 'md:ml-auto' : 'md:mr-auto'
                    }`}>
                      <span className="text-[#00d4aa] font-mono font-bold text-xl">
                        {milestone.year}
                      </span>
                      <h3 className="text-[#f0f0f5] font-semibold text-lg mt-2">
                        {milestone.title}
                      </h3>
                      <p className="text-[#9ca3af] text-sm mt-1">
                        {milestone.description}
                      </p>
                    </div>
                  </div>

                  <div className="w-4 h-4 rounded-full bg-[#00d4aa] border-4 border-[#0a0a0f] z-10 hidden md:block" />

                  <div className="flex-1 hidden md:block" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#12121a] relative overflow-hidden">
        <div className="absolute inset-0 grid-pattern opacity-30" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <span className="text-[#00d4aa] font-mono text-sm mb-4 block">
            {'// BİRLİKTE ÇALIŞALIM'}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#f0f0f5] mb-6">
            Projeniz İçin{" "}
            <span className="gradient-text">Hazırız</span>
          </h2>
          <p className="text-[#9ca3af] mb-8 max-w-2xl mx-auto">
            Fikirlerinizi gerçeğe dönüştürmek için buradayız. 
            Hemen iletişime geçin ve projenizi konuşalım.
          </p>
          <Link
            to="/iletisim"
            className="btn-primary inline-flex items-center gap-2 text-lg px-8 py-4"
            data-testid="about-cta-btn"
          >
            <Terminal className="w-5 h-5" />
            İletişime Geç
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
